export const modules = {
    USERS: 1,
    SETTINGS: 2,
    DOCUMENTS: 3,
    OPERATIONS: 4,
    TREASURY: 5,
    STORE: 6,
    WORKSHOP: 7,
    BILLING: 8,
    RRHH: 9,
    MONITORING: 10,
    DRIVER: 11,
    BOOKEEPING: 12,
}


